import { useI18n } from '../../context/useI18n';
import ImageSourceField from './ImageSourceField';
import GymMinimalBrandingFields from './GymMinimalBrandingFields';
import { resolveMediaUrl } from '../../utils/mediaUrl';

const SOCIAL_KEYS = [
  { key: 'website', label: 'Web' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'facebook', label: 'Facebook' },
  { key: 'youtube', label: 'YouTube' },
  { key: 'tiktok', label: 'TikTok' },
  { key: 'whatsapp', label: 'WhatsApp (redes)' },
];

export default function WhiteLabelFields({ formData, setFormData, showDomain = true, minimalGym = false }) {
  const { t } = useI18n();

  /** Contexto gym virtual/sede: solo Mi Marca (logo, colores, WhatsApp). Sin redes ni marketing. */
  if (minimalGym) {
    return (
      <GymMinimalBrandingFields formData={formData} setFormData={setFormData} showBrandName={false} />
    );
  }

  const social = formData.social_links && typeof formData.social_links === 'object'
    ? formData.social_links
    : {};

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onSocial = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      social_links: { ...(prev.social_links || {}), [key]: value },
    }));
  };

  return (
    <div className="mt-6 pt-6 border-t border-slate-200">
      <h5 className="text-sm font-semibold text-stone-800 mb-4">
        {t('wl.title', 'Marca blanca — Gym / Coach')}
      </h5>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <ImageSourceField
          label={t('wl.favicon', 'Favicon')}
          value={formData.favicon_url || ''}
          onChange={(url) => setFormData((prev) => ({ ...prev, favicon_url: url }))}
          alt="Favicon"
        />
        <ImageSourceField
          label={t('wl.cover', 'Portada')}
          value={formData.cover_url || ''}
          onChange={(url) => setFormData((prev) => ({ ...prev, cover_url: url }))}
          alt="Portada"
        />
        {showDomain && (
          <div className="md:col-span-2">
            <label className="label">{t('wl.domain', 'Dominio futuro')}</label>
            <input
              className="input font-mono text-sm"
              name="custom_domain"
              value={formData.custom_domain || ''}
              onChange={onChange}
              placeholder="app.mimarca.com"
            />
          </div>
        )}
      </div>
      <p className="text-xs text-stone-500 mt-3 mb-2">{t('wl.social', 'Redes sociales')}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
        {SOCIAL_KEYS.map(({ key, label }) => (
          <div key={key}>
            <label className="label text-xs">{label}</label>
            <input
              className="input text-sm"
              value={social[key] || ''}
              onChange={(e) => onSocial(key, e.target.value)}
              placeholder={key === 'website' ? 'https://' : '@usuario'}
            />
          </div>
        ))}
      </div>
      {(formData.cover_url || formData.favicon_url) && (
        <div className="mt-4 flex gap-4 items-start">
          {formData.cover_url && (
            <img src={resolveMediaUrl(formData.cover_url)} alt="" className="h-20 w-32 object-cover rounded-lg border border-slate-200" />
          )}
          {formData.favicon_url && (
            <img src={resolveMediaUrl(formData.favicon_url)} alt="" className="h-12 w-12 object-contain rounded border border-slate-200" />
          )}
        </div>
      )}
    </div>
  );
}
